import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {mergeArrayByKey, fetchDownload} from "../../common/util";
import { fileIconBasedOnFileName } from "../../containers/WorkkardDetail/utils";
import ImageTemplate from './imageTemplate';
import VideoTemplate from './videoTemplate';
import DefaultTemplate from './defaultTemplate';
const Viewer=require('react-viewer');
import { FileListing } from '../../containers/WorkkardDetail/constants';
import { showDialogueBox, hideDialogueBox } from '..//DialogueBox/actions';
import ConfirmationTextBox from "../ConfirmationPrompt";

class FileView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.renderFileListing=this.renderFileListing.bind(this);
        this.truncateFileName=this.truncateFileName.bind(this);
        this.handleSaveCaption=this.handleSaveCaption.bind(this);
        this.handleDeleteCaption=this.handleDeleteCaption.bind(this);
        this.state={
            imageFiles:[],
            showViewer:false,
            currentSelected: '',
            isPrintPreview:false,
            imageSources:{},
            viewerKey:0
        }
        this.handleViewerChange=this.handleViewerChange.bind(this);
    }

    componentWillUnmount(){
        Object.values(this.state.imageSources).forEach(url=>window.URL.revokeObjectURL(url));
    }

    // FilePreviewUrl is not loadable (and is static for GIFs), so the viewer shows the original file from the download api
    loadImageSource(guid){
        if(!guid || this.state.imageSources[guid]) return Promise.resolve();
        return fetchDownload(guid)
            .then((response)=>{
                const url = window.URL.createObjectURL(response.data);
                this.setState(prevState=>({imageSources:{...prevState.imageSources,[guid]:url}}));
            })
            .catch(()=>{});
    }

    openViewer(guid){
        this.activeGuid = guid;
        this.loadImageSource(guid).then(()=>this.setState({showViewer:true, currentSelected:guid}));
    }

    handleViewerChange(activeImage){
        const guid = activeImage && activeImage.guid;
        if(!guid || this.state.imageSources[guid]) return;
        this.activeGuid = guid;
        // The viewer sizes an image only when it is shown, so remount it once the image has loaded
        this.loadImageSource(guid).then(()=>{
            if(this.state.showViewer && this.activeGuid === guid){
                this.setState(prevState=>({currentSelected:guid, viewerKey:prevState.viewerKey+1}));
            }
        });
    }

    componentDidMount(){
        this.props.galleryData && this.props.galleryData.map((item,index)=>{
            if(item != undefined && item.length !=0 ){
                const structuredData = item.map((files)=>({
                    'src' : files.FilePreviewUrl,
                    'alt' : files.FileName,
                    'downloadUrl':files.FileUrl,
                    'guid':files.FileGuid
                }))
                this.setState(prevState=>{return {imageFiles: mergeArrayByKey(structuredData,prevState.imageFiles,'downloadUrl')}});
            }
        })
        if(Object.keys(this.props.printData).length > 0){
            this.setState({
                isPrintPreview:true
            })
        }
    }

    UNSAFE_componentWillReceiveProps(newProps){
        newProps.galleryData && newProps.galleryData.map((item,index)=>{
            if(item != undefined && item.length !=0 ){
                const structuredData = item.map((files)=>({
                    'src' : files.FilePreviewUrl,
                    'alt' : files.FileName,
                    'downloadUrl':files.FileUrl,
                    'guid':files.FileGuid
                }))
                this.setState(prevState=>{return {imageFiles: mergeArrayByKey(structuredData,prevState.imageFiles,'downloadUrl')}});
            }
        })
        if(Object.keys(newProps.printData).length != Object.keys(this.props.printData).length){
            if(Object.keys(newProps.printData).length >0){
                this.setState({
                    isPrintPreview:true
                })
            }
            else{
                this.setState({
                    isPrintPreview:false
                })
            }            
        }
    }

    renderFileListing(data){
        const classifiedType = data.FileType === "Image" || data.FileType === "Video"
            ? data.FileType
            : (() => {
                const icon = fileIconBasedOnFileName(data.FileType || (data.FileName || '').split('.').pop() || '');
                if (icon === 'Image') return 'Image';
                if (icon === 'video') return 'Video';
                return data.FileType;
            })();
        switch(classifiedType){
            case "Image":
                return <ImageTemplate
                data={data}
                cvData={this.props.cvData || null}
                handleSelectAllShow={this.props.handleCheckboxChange} isSelectAll={this.props.isSelectAll} EditableMode={this.props.EditableMode} handleDisplayViewer={(viewer,currentSelected)=>{ viewer && this.openViewer(currentSelected) }}
                truncateFileName={this.truncateFileName}
                handleSaveCaption={this.handleSaveCaption}
                handleDeleteCaption={this.handleDeleteCaption}
                isPrintPreview={this.state.isPrintPreview}
                galleryData={this.props.galleryData}
                extraData={this.props.extraData}/>;
            case "Video":
                return <VideoTemplate
                data={data}
                cvData={this.props.cvData || null}
                handleSelectAllShow={this.props.handleCheckboxChange} isSelectAll={this.props.isSelectAll}
                EditableMode={this.props.EditableMode}
                truncateFileName={this.truncateFileName}
                handleSaveCaption={this.handleSaveCaption}
                handleDeleteCaption={this.handleDeleteCaption}
                extraData={this.props.extraData}
                largeView={this.props.largeView}
                isPrintPreview={this.state.isPrintPreview}
                />;
            default:
                return <DefaultTemplate
                data={data}
                cvData={this.props.cvData || null}
                handleSelectAllShow={this.props.handleCheckboxChange}
                isSelectAll={this.props.isSelectAll}
                EditableMode={this.props.EditableMode}
                truncateFileName={this.truncateFileName}
                handleSaveCaption={this.handleSaveCaption}
                handleDeleteCaption={this.handleDeleteCaption}
                extraData={this.props.extraData}
                isPrintPreview={this.state.isPrintPreview}
                />;
        }
    }

    handleDeleteCaption(data){
        this.props.showDialogueBox({
            flag: true,
            component: <ConfirmationTextBox
                class={"modalBody"}
                message={"Are you sure you want to delete this caption ?"}
                onConfirmClick={()=>{
                    this.handleSaveCaption("",data);
                    if(this.props.extraData && this.props.extraData.isDiaryDetailPopUp){
                        this.props.extraData.deleteCaptionCallBack();
                    }
                    else{
                        this.props.hideDialogueBox();
                    }
                }}
                onCancelClick={()=>{
                    if(this.props.extraData && this.props.extraData.isDiaryDetailPopUp){
                        this.props.extraData.deleteCaptionCallBack();
                    }
                    else{
                        this.props.hideDialogueBox();
                    }
                }}
                confirmationText={"Delete Caption"}
                footerClass={"modalFooter"}
                cancelText={"Cancel"}
            />,
            overlayClassName: "modal",
            contentClassName: "modalContent small animated faster fadeInUpx2",
            shouldCloseOnOverlayClick: true
        });
    }

    handleSaveCaption(caption,data){
        const module = data.Ftype
            ? (data.Ftype.toUpperCase() === 'ACTIVITY' ? 'act' : 'wrk')
            : (data.NoteCategory === 'WorkkardNoteFile' ? 'wrk_note' : 'note');
        const id = data.Ftype
            ? data.Id
            : data.FileId;
        const payload={
            id: id ?? (this.props.cvData ? this.props.cvData.Id : ""),
            module,
            fid:data.FileGuid,
            nid:data.NoteId || (this.props.cvData ? this.props.cvData.note_id : ""),
            category:data.NoteCategory || (this.props.cvData ? this.props.cvData.NoteCategory :""),
            caption:caption,
            send_date:this.props.cvData ? this.props.cvData.send_date : ""
        }
        this.props.updateFileCaption(payload);
    }

    truncateFileName(fileName){
        const splitFileName=fileName.split('.');
        let TruncateFileName = splitFileName[0].length > FileListing.maxLengthToTruncateFileName ? fileName.substring(FileListing.startIndexOfSubstringTruncateFileName,FileListing.endIndexOfSubstringTruncateFileName) + "..."+fileName.slice(fileName.length-8) : fileName;
        return TruncateFileName;
    }

    handleDisplayViewer(){
        if(this.state.showViewer){
            const indexVal = this.state.imageFiles.findIndex(item=>item.guid===this.state.currentSelected);
            const selectedIndex = (this.state.currentSelected != '' && (indexVal != -1))? indexVal : 0;
            const images = this.state.imageFiles.map(item=>({
                ...item,
                src: item.guid ? (this.state.imageSources[item.guid] || '') : item.src
            }));
            return (<Viewer
                key={this.state.viewerKey}
                visible={this.state.showViewer}
                onClose={() => { this.setState({showViewer:false}) } }
                onChange={this.handleViewerChange}
                images={images}
                downloadable={true}
                zoomSpeed={0.2}
                activeIndex={selectedIndex}
                defaultSize={{width:800, height:600}}
                drag={false}
            />)
        }
        return null;
    }

    render() {
        const data=this.props.fileData;
        return (
            <div className="fileView">
                 <ul>
                    {
                        data.Files
                        &&
                        data.Files.length> 0
                        && data.Files.map((file, fileKey) => (
                            <li key={fileKey}>
                                {this.renderFileListing(file)}
                            </li>
                        ))
                    }
                    {/* {
                        <span className="mt__1 alignRight flexGrow downloadAll"><a href="javascript:void(0)" onClick={() => this.handleDownloadAllCellFiles(data.Files)}>Download all</a></span>
                    } */}
                </ul>
                {
                    this.handleDisplayViewer()
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    largeView: state.workkardDetail.middlePanel.files.largeView,
    printData:state.workkardDetail.combinedView.printData,
});

const mapDispatchToProps = (dispatch) => ({
    showDialogueBox: bindActionCreators(showDialogueBox, dispatch),
    hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FileView);